import { render } from "./ListScroll2.vue?vue&type=template&id=794e026f"
import script from "./ListScroll2.vue?vue&type=script&lang=js"
export * from "./ListScroll2.vue?vue&type=script&lang=js"

import "./ListScroll2.vue?vue&type=style&index=0&id=794e026f&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__